
import { api } from "roboflex-thalamus-request-handler";
import { flattenSetoresArvore } from "@/utils/setor-hierarquia";

function obterTodos(){
    return new Promise((resolve, reject) => {
        return api.get('setor')
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
} 


function obterPorId(id){
    return new Promise( (resolve, reject) => {
        return api.get(`setor/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });

}

/** Extrai array do corpo da resposta (vários formatos comuns de API Laravel / resource). */
function extrairListaSetores(res) {
    const body = res?.data;
    if (Array.isArray(body)) return body;
    if (body && Array.isArray(body.data)) return body.data;
    if (body?.data?.data && Array.isArray(body.data.data)) return body.data.data;
    return [];
}

/** Árvore hierárquica de setores (`GET setor/hierarquico`). */
function obterHierarquia() {
    return api
        .get("setor/hierarquico")
        .then((response) => extrairListaSetores(response))
        .catch((error) => Promise.reject(error));
}

/** Lista plana em ordem organizacional (pais antes dos filhos) para combos de visita. */
function obterListaEstruturaHierarquica() {
    return obterHierarquia().then((arvore) =>
        flattenSetoresArvore(arvore)
            .map((s) => ({ ...s, nome: (s.nome ?? "").trim() }))
            .filter((s) => s.nome)
    );
}

/** Todos os setores da estrutura (id, nome, setor_pai) — para combos / filtros. Retorna sempre um array. */
function obterTodosEstrutura() {
    return api
        .get("setor/todos")
        .then((response) => extrairListaSetores(response))
        .catch((error) => Promise.reject(error));
}

export default {
    obterTodos,
    obterPorId,
    obterHierarquia,
    obterListaEstruturaHierarquica,
    obterTodosEstrutura,
    extrairListaSetores,
}
